import { Injectable, signal } from '@angular/core';

/** Page-driven state of the global landing header. */
@Injectable({ providedIn: 'root' })
export class LandingHeaderService {
  readonly showApply = signal(false);
}
